import { Dialog } from '@mui/material';
import { FC, useCallback, useEffect } from 'react';
import { getShopAttributesFormRequest } from 'redux/reducers/shops/reducer';
import { useDispatch } from 'react-redux';
import { MapFields } from '../AddShopDialog/MapFields';

export const MapFieldsDialog: FC<{
	open: boolean;
	onClose: () => void;
	shopId: number | null;
}> = ({ open, onClose, shopId }) => {
	const dispatch = useDispatch();

	const handleSetStep = useCallback((step: number) => {
		// This function is not used in the dialog context, so we can leave it empty
	}, []);

	useEffect(() => {
		console.log('shopId', shopId);

		if (shopId) {
			dispatch(getShopAttributesFormRequest({ shopId }));
		}
	}, [shopId, dispatch]);

	return (
		<Dialog open={open} fullWidth maxWidth="sm">
			<MapFields open={open} onClose={onClose} setStep={handleSetStep} shopId={shopId} />
		</Dialog>
	);
};
